const SubscriptionSkuEnum = Object.freeze({
	// the sku for the item that needs a displayName option
	YEARLY_SUBSCRIPTION_SKU: "beast-yearly",
	MONTHLY_SUBSCRIPTION_SKU: "beast-monthly",
	SUBSCRIPTION_CODE_SKU: "beast-bulk-codes",
});

const BUNDLE_GRADE_PREFIX = "bundle-grade-";

module.exports = {
	SubscriptionSkuEnum,
	BUNDLE_GRADE_PREFIX,
};
